import { z } from 'zod';

export const meetingNoteSummarySchema = z
  .object({
    id: z.number().int(),
    document_id: z.string(),
    content: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
  })
  .transform((raw) => ({
    id: String(raw.id),
    documentId: raw.document_id,
    content: raw.content,
    createdAt: raw.created_at,
    updatedAt: raw.updated_at,
  }));

export type MeetingNoteSummaryResponseApi = z.input<typeof meetingNoteSummarySchema>;
export type MeetingNoteSummaryResponse = z.infer<typeof meetingNoteSummarySchema>;

export type MeetingNotesErrorEventPayload = {
  message?: string;
  error?: string;
  detail?: string;
};

export type MeetingNotesSseHandlers = {
  onStart?: () => void;
  onToken?: (content: string) => void;
  onStatus?: (message: string) => void;
  onComplete?: (summary: MeetingNoteSummaryResponse) => void;
  onError?: (message: string) => void;
};
